import { motion } from "framer-motion";

const spring = { type: "spring", damping: 20, stiffness: 100 };

export function Reveal({ children, delay = 0, y = 40, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ ...spring, delay }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for headings
export function MaskedLines({ lines = [], className = "", lineClass = "", delay = 0 }) {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line" aria-hidden="true">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
